import React, {useState, useEffect, useContext} from "react";
import { getReproductionsByUser } from "../../../api/reproductionApi";
import ReproWheel from "./EleveurReproductionWheel";
import { changeReproductionStatusE } from "../../../api/reproductionApi";
import { AuthContext } from "../../../Contexts/AuthContext";

export const EleveurReproduction = () => {
    const {user} = useContext(AuthContext);
    const [reproductions, setReproductions] = useState([]);
    const idU = user.id;
  useEffect(() => {
    loadReproductions();
  }, []);

  const loadReproductions = () => {
    getReproductionsByUser(idU).then(res => setReproductions(res.data));
  };

  const handleStatusChange = async (id, newStatus, preserveDates = false) => {
  try {
    await changeReproductionStatusE(id, newStatus, preserveDates);

    const fresh = await getReproductionsByUser(idU);
    setReproductions(fresh.data);

  } catch (err) {
    console.error("Status change failed:", err);
    throw err;
  }
};

  return (
    <div>
      <ReproWheel reproductions={reproductions} onStatusChange={handleStatusChange} />
    </div>
  );
};